/* global jsVars */

import algoliasearch from 'algoliasearch/lite';
import { getAlgoliaResults } from '@algolia/autocomplete-js';
import debouncePromise from '../util/debouncePromise';

const debounced = debouncePromise((items) => Promise.resolve(items), 300);

export const searchbarCategories = {
  getSources() {
    const appId = jsVars.algolia.applicationId;
    const apiKey = jsVars.algolia.searchOnlyPublicApiKey;
    const searchClient = algoliasearch(appId, apiKey);

    return debounced([
      {
        sourceId: 'wc-product-categories',
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: 'wp_terms_product_cat',
                query,
                // filters: `lang:${jsVars.currentLanguage}`,
              },
            ],
          });
        },
        templates: {
          header() {
            return jsVars.translations.categories;
          },
          item({ item, components, html }) {
            return html`<a class="js-searchbar-panel-category" href="${item.permalink}">
              ${components.Highlight({ hit: item, attribute: 'name' })}
            </a>`;
          },
          noResults() {
            return jsVars.translations.noCategories;
          },
        },
      },
    ]);
  },
};



// WEBPACK FOOTER //
// ./scripts/components/searchbar-categories.js